import {Repository} from '@/repositories/Base/Repository'

class ResultRangeRepository extends Repository {
    endpoint = 'mapping/result_range/observation'
}

export default new ResultRangeRepository()